module.exports = __webpack_public_path__ + "static/media/7news-play-arrow.32e5d22a.svg";